class EditorialTheme {
  constructor() {
    this.init();
  }

  init() {
    this.initScrollAnimations();
    this.initNavbarScroll();
  }

  initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;

    const elements = document.querySelectorAll('[data-animate]');

    if (elements.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    elements.forEach((el) => observer.observe(el));
  }

  initNavbarScroll() {
    const navbar = document.querySelector('[data-editorial-navbar]');
    if (!navbar) return;

    const handleScroll = () => {
      requestAnimationFrame(() => {
        navbar.classList.toggle('is-scrolled', window.scrollY > 50);
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new EditorialTheme();
});
